import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelectedDateQuery } from '../react-queries/queries';
import { useUpdateSelectedDateMutation } from '../react-queries/mutations';

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

const CalendarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 16px 20px;
`;

const Day = styled.div`
  text-align: center;
  color: #888;
  font-size: 12px;
`;

const DateNum = styled.div<{ active?: boolean; pressed?: boolean }>`
  width: 40px;
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 500;
  background: ${({ active, pressed }) =>
    pressed ? '#003fa0' : active ? '#0057ff' : 'transparent'};
  color: ${({ active, pressed }) =>
    pressed ? '#fff' : active ? '#fff' : '#7d7d7d'};
  cursor: pointer;
  transition: background 0.12s;
`;

const DayNumWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SelectedOval = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0057ff;
  border-radius: 20px;
  padding: 7px 2px 2px 2px;
`;

// 선택된 날짜를 관리하는 쿼리 키
const SELECTED_DATE_KEY = 'selectedDate';

// 선택된 날짜를 가져오는 함수
const getSelectedDate = (): Date => {
  //const storedDate = localStorage.getItem(SELECTED_DATE_KEY);
  //return storedDate ? new Date(storedDate) : new Date();
  return new Date();
};

// 선택된 날짜를 저장하는 함수
const setSelectedDate = (date: Date): void => {
  //localStorage.setItem(SELECTED_DATE_KEY, date.toISOString());
};

const Calendar: React.FC<{ onCalendarClick: (date: Date) => void }> = ({ onCalendarClick }) => {
  //const { data: selectedDate = new Date() } = useSelectedDateQuery();
  const selectedDate = getSelectedDate();
  //const { mutate: updateSelectedDate } = useUpdateSelectedDateMutation();

  const today = new Date();
  console.log("today : " + today.getDay(), ", today.getDate() : " + today.getDate());
  const week = Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    //d.setDate(today.getDate() - 7 - today.getDay() + 1 + i);
    d.setDate(today.getDate() - (today.getDay()===0? 6 : (today.getDay() - 1)) + i);
    return d;
  });

  const [pressedIdx, setPressedIdx] = useState<number | null>(null);

  const handleDateClick = (date: Date) => {
    //setSelectedDate(date);
    //updateSelectedDate(date);
    onCalendarClick(date);
  };

  const handlePress = (idx: number) => setPressedIdx(idx);
  const handleRelease = () => setPressedIdx(null);

  return (
    <CalendarWrapper>
      {week.map((date, idx) => {
        const isSelected =
          date.getDate() === selectedDate.getDate() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getFullYear() === selectedDate.getFullYear();
        const isPressed = pressedIdx === idx;
        return (
          <DayNumWrapper
            key={idx}
            onClick={() => handleDateClick(date)}
            onMouseDown={() => handlePress(idx)}
            onMouseUp={handleRelease}
            onMouseLeave={handleRelease}
            onTouchStart={() => handlePress(idx)}
            onTouchEnd={handleRelease}
            style={{ cursor: 'pointer' }}
          >
            {isSelected ? (
              <SelectedOval>
                <Day style={{ color: '#fff', fontWeight: 700 }}>{days[idx]}</Day>
                <DateNum active pressed={isPressed}>{date.getDate()}</DateNum>
              </SelectedOval>
            ) : (
              <>
                <Day>{days[idx]}</Day>
                <DateNum pressed={isPressed}>{date.getDate()}</DateNum>
              </>
            )}
          </DayNumWrapper>
        );
      })}
    </CalendarWrapper>
  );
};

export default Calendar; 